import { Component } from '@angular/core';
import {NavController, ToastController} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import {AssetsPage} from "../assets/assets";
import {FleetsService} from "../../services/fleets.service";
import {CompaniesService} from "../../services/companies.service";
import {UtilsService} from "../../services/utils.service";
import {AssetsService} from "../../services/assets.service";
import {DriversService} from "../../services/drivers.service";
import {SensorUtilService} from "../../services/sensors.service";
import {LoginPage} from "../login/login";
import {AuthService} from "../../services/auth.service";
import {NetworkService} from "../../services/network.service";

@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html'
})
export class SplashPage{

  public assets: any;
  private companies: any = [];
  private fleets: any = [];
  private ids: any = [];
  private fleetsIds: any = [];

  private selectedCompany: any;
  private selectedFleet: any;

  constructor(public navCtrl: NavController,
              private toastCtrl: ToastController,
              private networkService: NetworkService,
              private companiesService: CompaniesService,
              private authService: AuthService,
              private fleetService : FleetsService,
              private utilsService : UtilsService,
              private assetsService : AssetsService,
              private driversService : DriversService,
              private sensorUtilService : SensorUtilService,
              public storage: Storage) {}

  checkNetwork() {
    let toast = this.toastCtrl.create({
      message: 'Pas de connexion Internet!',
      position: 'bottom',
      showCloseButton: true
    });
    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    this.networkService.onConnexionLost().subscribe((data) =>{
      toast.present();
    });

    this.networkService.onConnexion().subscribe(()=>{
      toast.dismiss();
      this.dataInit();
    });

    this.storage.ready().then(()=>{
      this.storage.set('baselayer', 'NGI');
    });

  }


  ngOnInit() {

    /**
     * On init check if user is already signed in
     * if True redirect to Home screen
     * else initialize user
     */

    this.checkNetwork();
    this.dataInit();
    this.storage.set('deviceParams', {username: '', password : ''});
  }


  dataInit(){
    this.storage.ready().then(()=>{
      this.storage.get('token').then(token => {
        this.storage.get('user').then(user => {
          if(token && user && token != null && user != null && token != undefined && user != undefined && token != '' && user != ''){
            Promise.resolve(token).then(()=>{
              if(this.authService.hasPermission(user,'asset_groupe', 'u')){
                // if (user._role._id === "PUBLIC_USER") {
                this.fleetsIds = user._asset_groupe;
                this.loadUsersFleets();

              }
              else if(this.authService.hasPermission(user,'asset', 'u')){
                this.ids = user._asset;
                this.loadAssets();
              }
              else {
                if(this.authService.hasPermission(user,'company', 'x') || this.authService.hasPermission(user, 'company', 'a')){
                  this.loadCompanies();
                }else{
                  this.selectedCompany= user._company_owner;
                  this.companies= [user._company_owner];
                  this.loadFleets();
                }

              }
            })

          }else{
            this.navCtrl.setRoot(LoginPage);
          }
        });
      });
    });
  }


  loadCompanies(){

    this.checkNetwork();

    this.companiesService.getCompanies({}, 1000, 1).subscribe((data)=>{
      this.companies = data.result;
      this.selectedCompany = this.companies[0];
      this.loadFleets();
    },(err)=>{
      this.storage.get('auth').then(auth=>{
        if(auth){
          this.authService.connect(auth).subscribe((data)=>{
            let response = data.result;
            if(response && response.user){
              this.authService.setAuthData(auth, response.user, response.token);
              this.navCtrl.setRoot(SplashPage);
            }else{
              this.navCtrl.setRoot(LoginPage);
            }
          })
        }else{
          this.navCtrl.setRoot(LoginPage);
        }
      });
    });

  }
  loadUsersFleets(){
    this.fleetService.getFleetList({
      query: {
        _id: this.fleetsIds
      },
      options: {
        populate: [{
          path: '_assets',
          select: '_id'
        }
        ]
      }
    }, 1000, 1).subscribe((data)=>{

      if(data.success){
        this.fleets = data.result;
        console.log("this.fleets  ",this.fleets )
        this.selectedFleet = this.fleets[0];
        if(this.selectedFleet){
          for(let asset of this.selectedFleet._assets){
            this.ids.push(asset._id)
          }
          Promise.resolve(this.assets).then(()=>{
            this.loadAssets();
          })
        }
      }else{
      }
    }, (err)=>{
      this.storage.get('auth').then(auth=>{
        if(auth){
          this.authService.connect(auth).subscribe((data)=>{
            let response = data.result;
            if(response && response.user){
              this.authService.setAuthData(auth, response.user, response.token);
              this.navCtrl.setRoot(SplashPage);
            }else{
              this.navCtrl.setRoot(LoginPage);
            }
          })
        }else{
          this.navCtrl.setRoot(LoginPage);
        }
      });
    });
  }
  loadFleets(){
    this.fleetService.getFleetList({
      query: {
        _company_owner: this.selectedCompany._id
      },
      options: {
        populate: [{
          path: '_assets',
          select: '_id'
        }
        ]
      }
    }, 1000, 1).subscribe((data)=>{

      if(data.success){
        this.fleets = data.result;
        this.selectedFleet = this.fleets[0];
        if(this.selectedFleet){
          for(let asset of this.selectedFleet._assets){
            this.ids.push(asset._id)
          }
          Promise.resolve(this.assets).then(()=>{
            this.loadAssets();
          })
        }
      }else{
      }
    }, (err)=>{
      this.storage.get('auth').then(auth=>{
        if(auth){
          this.authService.connect(auth).subscribe((data)=>{
            let response = data.result;
            if(response && response.user){
              this.authService.setAuthData(auth, response.user, response.token);
              this.navCtrl.setRoot(SplashPage);
            }else{
              this.navCtrl.setRoot(LoginPage);
            }
          })
        }else{
          this.navCtrl.setRoot(LoginPage);
        }
      });
    });
  }

  loadAssets(){
    this.driversService.getDrivers({assetIds:this.ids}).subscribe(data => {
      this.assets = data.result;
      if(this.assets && this.assets.length>0) {
        this.assets = this.assetsService.getAssetsIcons(this.assets);
        this.loadAddress();
      }
      this.navCtrl.setRoot(AssetsPage, {
        companies: this.companies,
        fleets: this.fleets,
        assets: this.assets,
        ids: this.ids
      });

    },(err)=>{
      this.storage.get('auth').then(auth=>{
        if(auth){
          this.authService.connect(auth).subscribe((data)=>{
            let response = data.result;
            if(response && response.user){
              this.authService.setAuthData(auth, response.user, response.token);
              this.navCtrl.setRoot(SplashPage);
            }else{
              this.navCtrl.setRoot(LoginPage);
            }
          })
        }else{
          this.navCtrl.setRoot(LoginPage);
        }
      });
    })
  }

  loadAddress(){
    let coordinates = [];
    let result = [];
    for(let asset of this.assets) {
      if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[0]) {
        coordinates.push([asset.rt.loc.coordinates[0], asset.rt.loc.coordinates[1]])
      } else {
        coordinates.push([0, 0])

      }
    }

    if (coordinates.length > 0){
      this.utilsService.getAddress(coordinates).subscribe(data => {
        let res = data.BND.BatchResults;

        if (res.length > 0) {
          for(let value of res){
            if (value.Elements.count > 0) {
              let element = value.Elements.Element[0];
              let address = this.utilsService.format(element);
              result.push(address);
            }
            else
              result.push("Not available")
          }
        }


        let i = 0;
        for(let asset of this.assets) {
          if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[1] !== 0 && asset.rt.loc.coordinates[0] && asset.rt.loc.coordinates[0] !== 0)
            asset.address = result[i];
          i++;
          this.getAssetSensors(asset);
        }
      });
    }
  }

  getAssetSensors(asset){
    let sensors = asset.sensors;
    asset.sensorData = [];
    if(sensors.length > 0){
      for(let sensor of sensors){
        let sensorName = sensor.name;
        let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
        if (sensor.type && sensor.src && asset.rt &&asset.rt.io && Number.isFinite(asset.rt.io[src])) {
          let realVal = asset.rt.io[src];
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "ANALOGIC") {
            if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
              realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
            }
            if(sensor.type == "FUEL_LEVEL")
            sensor.value_pourcent =
                        (realVal / sensor.max) * 100;

                        if (Number.isFinite(realVal))
                          asset.sensorData.push({
                            name: sensorName,
                            type: sensor.type,
                            family: sensor.family,
                            unit: sensor.unit,
                            value: parseFloat(realVal.toFixed(2)),
                            value_pourcent:sensor.value_pourcent ? parseFloat(sensor.value_pourcent.toFixed(2)) :null
                          });
          }
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "BINARY") {

            asset.sensorData.push({
              name: sensorName,
              type: sensor.type,
              family: sensor.family,
              ON: sensor.ON,
              OFF: sensor.OFF,
              value:realVal,
              status: realVal === sensor.ON ? this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].enabled
              :  this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].disabled,
              class: realVal === sensor.ON ? "is-on" : "is-off"
            });
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts